// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Data
import { vehicles } from "pages/CarRentals/sections/data/carRentalData";

function Fleet() {
  return (
    <MKBox component="section" py={6}>
      <Container>
        <MKTypography variant="h3" textAlign="center" mb={1}>
          Our rental fleet
        </MKTypography>
        <MKTypography
          variant="body1"
          color="text"
          textAlign="center"
          mb={2}
          mx="auto"
          sx={{ maxWidth: 720 }}
        >
          Two vehicles to choose from &mdash; pick the one that fits your group, or grab both.
        </MKTypography>

        {vehicles.map((vehicle, index) => {
          const reverse = index % 2 === 1;
          return (
            <Grid
              container
              spacing={5}
              alignItems="center"
              key={vehicle.name}
              sx={{ mt: index === 0 ? 2 : { xs: 4, md: 7 } }}
            >
              <Grid item xs={12} md={6} sx={{ order: { xs: 1, md: reverse ? 2 : 1 } }}>
                <MKBox
                  component="img"
                  src={vehicle.image}
                  alt={vehicle.imageAlt}
                  loading="lazy"
                  sx={{
                    width: "100%",
                    display: "block",
                    borderRadius: "lg",
                    boxShadow: ({ boxShadows: { xxl } }) => xxl,
                  }}
                />
              </Grid>
              <Grid item xs={12} md={6} sx={{ order: { xs: 2, md: reverse ? 1 : 2 } }}>
                <MKTypography
                  variant="h6"
                  color="info"
                  fontWeight="bold"
                  textTransform="uppercase"
                  mb={1}
                >
                  {vehicle.eyebrow}
                </MKTypography>
                <MKTypography variant="h3" mb={2}>
                  {vehicle.name}
                </MKTypography>
                <MKTypography variant="body1" color="text" mb={3}>
                  {vehicle.description}
                </MKTypography>
                {vehicle.specs.map((spec) => (
                  <MKBox key={spec.label} display="flex" alignItems="center" mb={1.5}>
                    <Icon
                      sx={{
                        color: "info.main",
                        fontSize: "1.5rem !important",
                        mr: 1.5,
                        flexShrink: 0,
                      }}
                    >
                      {spec.icon}
                    </Icon>
                    <MKTypography variant="body1" color="dark" fontWeight="medium">
                      {spec.label}
                    </MKTypography>
                  </MKBox>
                ))}
              </Grid>
            </Grid>
          );
        })}
      </Container>
    </MKBox>
  );
}

export default Fleet;
